import * as actionTypes from "./actionTypes";

// Fetch all cancellations
export const fetchAllCancellationsRequest = () => ({
  type: actionTypes.FETCH_ALL_CANCELLATIONS_REQUEST,
});

export const fetchAllCancellationsSuccess = (cancellations) => ({
  type: actionTypes.FETCH_ALL_CANCELLATIONS_SUCCESS,
  payload: cancellations,
});

export const fetchAllCancellationsFailure = (error) => ({
  type: actionTypes.FETCH_ALL_CANCELLATIONS_FAILURE,
  payload: error,
});

// Fetch provider-specific cancellations
export const fetchProviderCancellationsRequest = (providerId) => ({
  type: actionTypes.FETCH_PROVIDER_CANCELLATIONS_REQUEST,
  payload: providerId,
});

export const fetchProviderCancellationsSuccess = (cancellations) => ({
  type: actionTypes.FETCH_PROVIDER_CANCELLATIONS_SUCCESS,
  payload: cancellations,
});

export const fetchProviderCancellationsFailure = (error) => ({
  type: actionTypes.FETCH_PROVIDER_CANCELLATIONS_FAILURE,
  payload: error,
});

// Apply fine to provider
export const applyCancellationFineRequest = (cancellationId, fineAmount) => ({
  type: actionTypes.APPLY_CANCELLATION_FINE_REQUEST,
  payload: { cancellationId, fineAmount },
});

export const applyCancellationFineSuccess = (updatedCancellation) => ({
  type: actionTypes.APPLY_CANCELLATION_FINE_SUCCESS,
  payload: updatedCancellation,
});

export const applyCancellationFineFailure = (error) => ({
  type: actionTypes.APPLY_CANCELLATION_FINE_FAILURE,
  payload: error,
});

// Update cancellation status
export const updateCancellationStatusRequest = (cancellationId, newStatus) => ({
  type: actionTypes.UPDATE_CANCELLATION_STATUS_REQUEST,
  payload: { cancellationId, newStatus },
});

export const updateCancellationStatusSuccess = (updatedCancellation) => ({
  type: actionTypes.UPDATE_CANCELLATION_STATUS_SUCCESS,
  payload: updatedCancellation,
});

export const updateCancellationStatusFailure = (error) => ({
  type: actionTypes.UPDATE_CANCELLATION_STATUS_FAILURE,
  payload: error,
});

// Fetch cancellation statistics
export const fetchCancellationStatisticsRequest = () => ({
  type: actionTypes.FETCH_CANCELLATION_STATISTICS_REQUEST,
});

export const fetchCancellationStatisticsSuccess = (statistics) => ({
  type: actionTypes.FETCH_CANCELLATION_STATISTICS_SUCCESS,
  payload: statistics,
});

export const fetchCancellationStatisticsFailure = (error) => ({
  type: actionTypes.FETCH_CANCELLATION_STATISTICS_FAILURE,
  payload: error,
});
